import { hasAnyPhysicalAssets } from './offer';

// eslint-disable-next-line import/prefer-default-export
export const missingNeededShippingAddress = (organization, offers) =>
  hasAnyPhysicalAssets(offers) && !organization.shippingAddress;
